import { useEffect, useState } from 'react';
import { findFolder, joinPath } from '@clodo/api';

// Recherche serveur avec anti-rebond.
//
// `onFolder(folder, isSearchFolder)` reçoit soit le dossier réel quand la
// requête est vide, soit un pseudo-dossier de résultats. Les deux fronts n'ont
// plus qu'à câbler un champ de saisie dessus.
export function useSearch({ api, root, path, limit, onFolder }){
    const [query, setQuery] = useState('');

    // On dépend de la FORME du chemin, pas de son identité : côté mobile il
    // vient de useLocalSearchParams() et c'est un tableau neuf à chaque rendu.
    // Dépendre du tableau lui-même relancerait l'effet en boucle et effacerait
    // la saisie à chaque frappe.
    const pathKey = joinPath(path);

    // Changer de dossier annule la recherche en cours.
    useEffect(() => {
        setQuery('');
    }, [pathKey]);

    useEffect(() => {
        if(query === ''){
            // Restaure l'affichage du dossier courant.
            const folder = findFolder(root, path);
            if(folder){ onFolder(folder, false); }
            return;
        }
        // Anti-rebond : sans lui, chaque frappe déclenche un parcours récursif
        // du disque côté serveur (Element::searchRecursive).
        const timer = setTimeout(() => {
            api.search(query, limit).then(results => {
                onFolder({ name : 'Results', type : 'folder', child : results || [] }, true);
            });
        }, 300);
        return () => clearTimeout(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query, limit, pathKey]);

    return { query, setQuery };
}
